import { render } from "./ClientCases.vue?vue&type=template&id=181d76bc"
import script from "./ClientCases.vue?vue&type=script&lang=js"
export * from "./ClientCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/ClientCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "181d76bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('181d76bc', __exports__)) {
    console.log('reload')
    api.reload('181d76bc', __exports__)
  }
  
  module.hot.accept("./ClientCases.vue?vue&type=template&id=181d76bc", () => {
    console.log('re-render')
    api.rerender('181d76bc', render)
  })

}


export default __exports__